import { INDICATORS_REQUEST, INDICATORS_SUCCESS, INDICATORS_FAILURE } from '../Constants/ActionTypes';
import { toast } from 'react-toastify';
import * as API from '../API/api.js';

export const indicatorDetails = (values, token) => async dispatch => {
  try {
    dispatch({ type: INDICATORS_REQUEST });
    const data = await API.postIndicators(values, token);
    if (data) {
      dispatch({ type: INDICATORS_SUCCESS, payload: data });
      toast('Indicators Added Successfully');
    }
  } catch (error) {
    toast('DATA NOT DISPATCHED');
    dispatch({ type: INDICATORS_FAILURE });
  }
};

export const fetchIndicatorData = (token) => async dispatch => {
  try {
    dispatch({ type: INDICATORS_REQUEST });
    const { data } = await API.getIndicators(token);
    if (data) {
      dispatch({ type: INDICATORS_SUCCESS, payload: data });
      console.log("abcd", data);
    }
  } catch (error) {
    toast('ERROR IN FETCHING INDICATORS');
    console.log(error);
    dispatch({ type: INDICATORS_FAILURE });
  }
};
